import { useEffect } from 'react';
import analytics from '../utils/analytics';

const PerformanceMonitor = () => {
  useEffect(() => {
    // Track page load performance
    const trackPageLoadPerformance = () => {
      if ('performance' in window) {
        const navigation = performance.getEntriesByType('navigation')[0];
        if (navigation) {
          // Track DOM content loaded time
          analytics.trackPerformance('dom_content_loaded', navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart);
          
          // Track page load time
          analytics.trackPerformance('page_load_time', navigation.loadEventEnd - navigation.loadEventStart);
          
          // Track first contentful paint
          const paintEntries = performance.getEntriesByType('paint');
          const fcp = paintEntries.find(entry => entry.name === 'first-contentful-paint');
          if (fcp) {
            analytics.trackPerformance('first_contentful_paint', fcp.startTime);
          }
        }
      }
    };

    // Track user engagement metrics
    const trackUserEngagement = () => {
      let scrollDepth = 0;
      let timeOnPage = 0;
      const startTime = Date.now();

      // Track scroll depth
      const handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const newScrollDepth = Math.round((scrollTop + windowHeight) / documentHeight * 100);
        
        if (newScrollDepth > scrollDepth) {
          scrollDepth = newScrollDepth;
          if (scrollDepth % 25 === 0) { // Track every 25% scroll
            analytics.trackResultsInteraction('scroll_depth', `${scrollDepth}%`);
          }
        }
      };

      // Track time on page
      const trackTimeOnPage = () => {
        timeOnPage = Date.now() - startTime;
        if (timeOnPage > 30000) { // Track after 30 seconds
          analytics.trackSessionDuration(timeOnPage);
        }
      };

      // Add event listeners
      window.addEventListener('scroll', handleScroll);
      const timeInterval = setInterval(trackTimeOnPage, 10000); // Check every 10 seconds

      // Cleanup
      return () => {
        window.removeEventListener('scroll', handleScroll);
        clearInterval(timeInterval);
      };
    };

    // Track device and browser information
    const trackDeviceInfo = () => {
      const userAgent = navigator.userAgent;
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      
      analytics.trackResultsInteraction('device_info', `${screenWidth}x${screenHeight}`);
      
      // Track browser type
      let browser = 'unknown';
      if (userAgent.includes('Chrome')) browser = 'Chrome';
      else if (userAgent.includes('Firefox')) browser = 'Firefox';
      else if (userAgent.includes('Safari')) browser = 'Safari';
      else if (userAgent.includes('Edge')) browser = 'Edge';
      
      analytics.trackResultsInteraction('browser_type', browser);
    };

    // Initialize tracking
    trackPageLoadPerformance();
    trackDeviceInfo();
    const cleanup = trackUserEngagement();

    return cleanup;
  }, []);

  return null; // This component doesn't render anything
};

export default PerformanceMonitor; 